import React from "react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { getOcr } from "../../api/getOcr";
import Modal from 'react-bootstrap/Modal';

function Pantalla22() {

  const navigate = useNavigate();
  const isRunned = useRef(false);
  const [firstName, setFirstName] = useState("");
  const [paternalLastName, setPaternalLastName] = useState("");
  const [maternalLastName, setMaternalLastName] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [claveDeElector, setClaveDeElector] = useState("");
  const [curpStr, setCurpStr] = useState("");
  const [sexo, setSexo] = useState("");
  const [nacionalidad, setNacionalidad] = useState("");
  const [nacionalidadISO, setNacionalidadISO] = useState("");
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showMessage, setShowMessage] = useState('');

  const handleClose = () => {
    setShow(false);
    navigate("/?i=" + localStorage.getItem("sCpv"));
  }

  useEffect(() => {
    if (isRunned.current) return;
    setLoading(true);
    isRunned.current = true;

    async function createSession() {

      setLoading(true);

      const objIncode = {
        interviewId: localStorage.getItem("interviewIdINE"),
        tokenIncode: localStorage.getItem("tokenIncodeINE"),
        curpValidate: localStorage.getItem("curpValidate"),
        nombre: localStorage.getItem("nombre"),
        paterno: localStorage.getItem("paterno"),
        materno: localStorage.getItem("materno"),
      }

      const response = await getOcr(objIncode);

      if (response.status === 200) {

        setCurpStr(response.curp);
        setBirthDate(response.birthDateStr);

        setFirstName(localStorage.getItem("nombre"));
        setPaternalLastName(localStorage.getItem("paterno"));
        setMaternalLastName(localStorage.getItem("materno"));

        setClaveDeElector(response.curp);
        setSexo(response.sexo);
        setNacionalidad(response.nacionalidad);
        setNacionalidadISO(response.nacionalidadISO);
        setLoading(false);

      } else {

        setLoading(false);
        setShow(true);
        setShowStatus(response.status);
        setShowMessage(response.message);

      }
    }

    createSession();

  }, []);

  return (
    <>

      <div className="containerRender">
        {loading ? (
          <div className="spinner"></div>
        ) : (
          <div className="containerInfo_P2">
            <div className="containerIdent_P2">
              <div className="txtOp_P2">Nombres/Given names</div>
              <div className="txtVer_P2">{firstName}</div>
              <div className="txtCpv_P2">Apellidos/Surname</div>
              <div className="txtVer_P2">
                {paternalLastName} {maternalLastName}
              </div>
              <div className="txtOp_P2">Fecha de nacimiento/Date of birth</div>
              <div className="txtVer_P2">{birthDate}</div>
              <div className="txtOp_P2">Sexo/Sex</div>
              <div className="txtVer_P2">{sexo}</div>
              <div className="txtOp_P2">Nacionalidad/Nationality</div>
              <div className="txtVer_P2">{nacionalidadISO} {nacionalidad}</div>
              <div className="txtOp_P2">
                Número de Identificación/Identity Number
              </div>
              <div className="txtVer_P2">{claveDeElector}</div>
            </div>
          </div>
        )}
      </div>

      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body className='backGroudModal'>
          <div className='msjTitleModalDiv'>Error {showStatus}</div>
          <div className='msjErrorModal'>{showMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='button_P2' onClick={handleClose}>
            <span className='txtButton_P2'>Regresar</span>
          </button>
        </Modal.Footer>
      </Modal>

    </>
  );
}

export default Pantalla22;
